import type { QuoteItem } from './types';

export type QuoteDiscountParticipation = 'included' | 'excluded' | 'unknown';

/** Read only the exact frozen policy returned with this quote line. */
export function quoteDiscountParticipation(
  item: Pick<QuoteItem, 'pricingSnapshot'>,
): QuoteDiscountParticipation {
  const snapshot = item.pricingSnapshot;
  if (!snapshot || typeof snapshot !== 'object') return 'unknown';
  const policy = snapshot.packageGroupPolicy;
  if (Object.hasOwn(snapshot, 'packageGroupPolicy') && policy === null)
    return 'included';
  if (!policy || typeof policy !== 'object' || Array.isArray(policy))
    return 'unknown';
  const participates = (policy as Record<string, unknown>)
    .participatesInDiscount;
  return participates === false
    ? 'excluded'
    : participates === true
      ? 'included'
      : 'unknown';
}

/** A disabled discount means full base price; it never substitutes retail price. */
export function quoteItemEffectiveDiscount(
  item: Pick<QuoteItem, 'pricingSnapshot'>,
  discount: number,
): number {
  return quoteDiscountParticipation(item) === 'excluded' ? 100 : discount;
}
